import React from "react";

import {
  FaPlus,
} from "react-icons/fa";

import AddRemitoForm from "./AddRemitoForm";

import "../css/admin.css";
import "../css/remitos.css";

const AddRemito = ({
  show,
  setShow,
}) => {
  const handleShow = () => {
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
  };

  return (
    <>
      <div className="rem2-add-row">
        <button
          type="button"
          className="rem2-add-button"
          onClick={handleShow}
        >
          <FaPlus />

          Nuevo remito
        </button>
      </div>

      <AddRemitoForm
        show={show}
        onClose={handleClose}
        onSaved={handleClose}
      />
    </>
  );
};

export default AddRemito;